export type StepperStatus = 'incomplete' | 'complete' | 'error' | 'warning' | 'in-progress';
